import { useState, type FormEvent } from "react";
import { Link, Navigate } from "react-router-dom";
import { useSessao } from "../sessao";
import { ProvedorAgua } from "../componentes/Agua";
import css from "./Entrar.module.css";

export function Entrar() {
  const { usuario, entrar, erroEntrada, carregando } = useSessao();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [enviando, setEnviando] = useState(false);

  if (carregando) return <div className={css.espera}>Carregando…</div>;
  if (usuario) return <Navigate to="/" replace />;

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setEnviando(true);
    try {
      await entrar(email, senha);
    } finally {
      setEnviando(false);
    }
  }

  return (
    <ProvedorAgua>
    <div className={css.tela}>
      <form className={css.caixa} onSubmit={(e) => void enviar(e)}>
        <h1>NECTUNO</h1>
        <p className={css.sub}>Licitações para o NECTAR</p>

        <label>
          E-mail
          <input
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.currentTarget.value)}
          />
        </label>
        <label>
          Senha
          <input
            type="password"
            autoComplete="current-password"
            required
            value={senha}
            onChange={(e) => setSenha(e.currentTarget.value)}
          />
        </label>
        <Link className={css.esqueci} to="/esqueci-senha">
          Esqueci minha senha
        </Link>

        {erroEntrada && <p className={css.erro}>{erroEntrada}</p>}

        <button type="submit" disabled={enviando}>
          {enviando ? "Entrando…" : "Entrar"}
        </button>

        <p className={css.ajuda}>
          Acesso é criado no servidor com{" "}
          <code>uv run nectuno-usuario --cria seu@email --papel operador</code>
        </p>
      </form>
    </div>
    </ProvedorAgua>
  );
}
